<template>
  <validation-observer
    ref="formModalObserver"
    tag="form"
    novalidate
    @submit.prevent="handleModalSubmit"
  >
    <div>
      <div class="p-2">
        <div class="bg-white border-radius--light py-2">
          <div class="col-12 mb-2">
            <em class="fas fa-times-square text-orange mr-1" />
            <strong>
              <span class="ml-2">Asignar Referido</span>
            </strong>
          </div>

          <div class="row p-4">
            <div class="col-sm-5">
              <validation-provider
                v-slot="{ errors }"
                mode="eager"
                rules="required"
              >
                <custom-drop-down
                  id="forAdmission"
                  v-model="model.specialist"
                  label="Especialista para Admisión:"
                  fieldkey="id"
                  fieldname="name"
                  placeholder="Seleccione"
                  :error="errors[0]"
                  custom-error-msg="Favor seleccionar especialista para Admisión"
                  :options="specialists"
                />
              </validation-provider>
            </div>
            <div class="col-sm">
              <div class="d-flex justify-content-end mt-4">
                <action-button
                  variant="danger mr-2"
                  i="fas fa-times-circle"
                  text="Cancelar"
                  @click="dispose"
                />
                <action-button
                  variant="success pl-4 pr-4"
                  text="Asignar"
                  @click="saveAssignment"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
// components
import CustomDropDown from "custom-drop-down";
import ActionButton from "ActionButton";
// mixins
import alert from "utils/mixins/alert.mixin";
// services
import {
  getSpecialistsForAssignment,
  saveAssignment as _saveAssignment
} from "@/modules/referral/api";
// 3rd parties lib
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  props: {
    admissionId: {
      type: Number,
      default: undefined
    },
    value: {
      type: Object,
      default: () => undefined
    },
    dispose: {
      type: Function,
      default: () => undefined
    }
  },
  components: {
    CustomDropDown,
    ActionButton,
    ValidationProvider,
    ValidationObserver
  },
  mixins: [alert],
  data() {
    return {
      assignSpecialists: [],
      specialists: [],
      model: {}
    };
  },
  async mounted() {
    await this.getSpecialistsForAssignment();
  },
  methods: {
    async getSpecialistsForAssignment() {
      const referral = this.value;
      const specialistId =
        referral.admissionSpecialist > 0 ? referral.admissionSpecialist : 0;

      const { data } = await getSpecialistsForAssignment(
        referral.admissionId,
        referral.locationFiscalYearId,
        referral.studentSieId,
        specialistId
      );
      this.specialists = data;
    },
    async saveAssignment() {
      const isValid = await this.$refs.formModalObserver.validate();

      if (!isValid) {
        this.ShowToast("Atención", "Información Incompleta.", "error");
        return;
      }

      const specialistId = this.model.specialist.id;

      await _saveAssignment({
        admissionId: this.value.admissionId,
        specialistId
      });

      this.ShowToast(
        "Proceso Exitoso",
        "Datos guardados satisfactoriamente.",
        "success"
      );

      this.dispose();

      this.$emit("refreshReferralResult");
    }
  }
};
</script>

<style scoped>
.info-panel {
  padding: 15px 10px 1px 20px;
  border: 6px solid #f2f2f2;
  border-radius: 0px 0px 5px 5px;
  opacity: 1;
}
</style>
